<template>
    <div class="wrapper">
        <div class="main-panel">
            <div class="main-content">
                <div class="content-wrapper">
                    <div class="container-fluid">
                        <section class="basic-elements">
                            <div class="row">
                                <div class="col-sm-12">
                                    <a class="btn btn-secondary float-right top-back-button" @click.prevent="back()"><i class="fa fa-arrow-left"></i></a>
                                    <h2 class="content-header">{{ $t("labels.editArticle") }}</h2>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="px-3">
                                                <form class="form">
                                                    <news-form :article="article" v-if="article._id"></news-form>
                                                    <div class="form-actions">
                                                        <button type="button" class="btn btn-info mr-1" @click.prevent="back()">
                                                            <i class="fa fa-arrow-left"></i> {{ this.$t("labels.back") }}
                                                        </button>
                                                        <button type="button" class="btn btn-success" @click.prevent="saveArticle()">
                                                            <i class="icon-note"></i> {{ this.$t("labels.save") }}
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NewsForm from '@/components/news/NewsForm'
import NewsService from '@/services/news'

export default {
    components: {
        NewsForm
    },
    data() {
        return {
            errors: [],
            article: {}
        }
    },
    methods: {
        back() {
          this.$router.push({ name: 'home'})
        },
        saveArticle: async function() {
            this.errors = []
            if (this.article.title.length == 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.title")]))
            }
            let slugRegex = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/
            if (this.article.slug.length == 0 || !this.article.slug.match(slugRegex)) {
                this.errors.push(this.$t("errors.slugInvalid"))
            }
            if (this.article.body.length == 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.articleBody")]))
            }
            if (this.errors.length === 0) {
                let formData = new FormData()
                formData.append('image', this.article.image)
                formData.append('article', JSON.stringify(this.article))
                let result = await NewsService.update(formData)
                if (result.data.success === true) {
                    this.$router.push({ name: 'newsList' })
                    this.$miniToastr.success(this.$t("flash.updateSuccess"))
                } else {
                    for (let error in result.data.errors) {
                        this.errors.push(result.data.errors[error].msg)
                    }
                    this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
                    this.errors = []
                }
            } else {
                this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
                this.errors = []
            }
        },
        back: function() {
          this.$router.push({ name: 'home' })
        }
    },
    mounted: async function() {
        let article = await NewsService.byId(this.$route.params.id)
        if (article) {
            this.article = article.data
        }
    }
}
</script>

<style lang="scss">
    form {
        padding-top: 15px;
    }
</style>